// Базовый URL API. В dev через Vite proxy, в prod через Nginx (путь /api/v1).
const API_BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? "/api/v1";

// Типы window.Telegram.WebApp — в types/telegram.d.ts.

// Читаем initData из Telegram WebApp (пустая строка вне TMA-контекста).
function initData(): string {
  return window.Telegram?.WebApp?.initData ?? "";
}

/**
 * Универсальный fetch-обёртка для API-запросов.
 * Автоматически добавляет заголовок Authorization: tma <initData>.
 * Бросает Error при нестатусе 2xx.
 */
export async function api<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers ?? {});
  // В Telegram авторизуемся через initData; на сайте — через cookie-сессию
  // (credentials: include), поэтому заголовок tma ставим только при наличии initData.
  const id = initData();
  if (id) headers.set("Authorization", `tma ${id}`);
  // Content-Type ставим только если есть тело, и он ещё не задан вручную.
  if (init.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const res = await fetch(`${API_BASE}${path}`, { ...init, headers, credentials: "include" });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`HTTP ${res.status}: ${text || res.statusText}`);
  }
  // 204 No Content: тела нет, возвращаем undefined.
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
